export enum FontType {
  TimesNewRoman = 1
}

export const FontTypeToString = {
  [FontType.TimesNewRoman]: "Times New Roman"
}